import apiClient from './apiClient';

export interface StartLeaguePurgeRequest {
  game: string;
  keepLeague: string;
}

export interface LeaguePurgeOption {
  game: string;
  league: string;
}

export interface LeaguePurgeDeletedCounts {
  characters: number;
  characterItemHistory: number;
  events: number;
  itemExchangeRates: number;
  divineOrbHistory: number;
  items: number;
  gameAccounts: number;
}

export interface LeaguePurgeScope {
  game: string;
  keepLeague: string;
  targetLeagues: string[];
  targetLeagueCount: number;
  targetCharacterCount: number;
}

export interface LeaguePurgeStatus {
  jobId: string;
  status: 'pending' | 'running' | 'completed' | 'failed';
  phase: string;
  progressPercent: number;
  processedWorkItems: number;
  totalWorkItems: number;
  scope: LeaguePurgeScope;
  deletedCounts: LeaguePurgeDeletedCounts;
  startedAt: string;
  finishedAt?: string;
  error?: string;
}

/**
 * Response type for the clear all old data operation
 */
export interface ClearAllOldDataResponse {
  success: boolean;
  itemSnapshotsDeleted: number;
  charactersDeleted: number;
  message: string;
}

/**
 * Clear all old data - Admin only operation
 * Deletes all item snapshots older than 14 days and characters not alive for more than 30 days
 * @returns Promise resolving to cleanup statistics
 */
export const clearAllOldData = async (): Promise<ClearAllOldDataResponse> => {
  try {
    const response = await apiClient.post<ClearAllOldDataResponse>('/items/cleanup/clear-all-old-data');
    return response.data;
  } catch (error: unknown) {
    throw error;
  }
};

export const startLeaguePurge = async (payload: StartLeaguePurgeRequest): Promise<LeaguePurgeStatus> => {
  const response = await apiClient.post<LeaguePurgeStatus>('/admin-cleanup/league-purge', payload);
  return response.data;
};

export const getLeaguePurgeOptions = async (): Promise<LeaguePurgeOption[]> => {
  const response = await apiClient.get<LeaguePurgeOption[]>('/admin-cleanup/league-options');
  return response.data;
};

export const getLeaguePurgeStatus = async (jobId: string): Promise<LeaguePurgeStatus> => {
  const response = await apiClient.get<LeaguePurgeStatus>(`/admin-cleanup/league-purge/${jobId}`);
  return response.data;
};
